import { get, getBlob, patch, post } from '../client';

export const userEquipmentApi = {
  list: (params) => get('/user-equipment', { params }),
  exportExcel: (params) => getBlob('/user-equipment/export', { params }),
  getById: (id) => get(`/user-equipment/${id}`),
  update: (id, body) => patch(`/user-equipment/${id}`, body),
  updateKyc: (id, body) => patch(`/user-equipment/${id}/kyc`, body),
  aiVerify: (id) =>
    post(`/user-equipment/${id}/ai-verify`, {}, { timeout: 120000 }),
  lastAiVerify: (id) => get(`/user-equipment/${id}/ai-verify/last`),
  indentHistory: (id) => get(`/user-equipment/${id}/indent-history`),
};
